import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { closeModal, fetchInventoryProducts } from '../../../../Features/inventoryManagementSlice';
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import { useOutsideClickForTwoRef } from '../../../../Hooks/useOutsideClickForTwoRef';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { getTags, updateProduct } from '../../../../lib/utils/apiCalls';
import Search from '../../../../Assets/Modals/SearchIcon.svg';
import CheckboxSelected from '../../../../Assets/Modals/CheckboxSelected.svg';
import CrossSmall from '../../../../Assets/CrossSmall.svg';
import { toast } from 'react-toastify';
import { InventoryManagementContext } from '../../../../Context/InventoryManagementContext';

function AddTags() {
    const dispatch = useDispatch();

    const searchInputBoxRef = useRef(null);
    const searchResultDropdownRef = useRef(null);

    const { selectedProducts, setSelectedProducts} = useContext(InventoryManagementContext);

    useOutsideClickForTwoRef(searchInputBoxRef, searchResultDropdownRef, () => {
        setSearchValue('');
    });

    const [searchValue, setSearchValue] = useState('');
    const [selectedTags, setSelectedTags] = useState([]);
    const [tagsList, setTagsList] = useState([]);

    const handleTagSearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearchKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(selectedTags.length < 5) {
                setSelectedTags([ ...selectedTags, searchValue]);
                setSearchValue('');
            }
            else {
                showToast('Max 5 tags allowed', 'warning');
            }
        }
    }

    const handleTagResultDropdownItemClick = (e, tag) => {
        e.stopPropagation();

        let isSelected = selectedTags.some(selected => selected === tag);

        if(isSelected) {
            let filteredList = selectedTags.filter(item => item !== tag);
            setSelectedTags(filteredList);
        }
        else {
            if(selectedTags.length < 5) {
                setSelectedTags([ ...selectedTags, tag]);
            }
            else {
                showToast('Max 5 tags allowed', 'warning');
            }
        }
    }

    useEffect(() => {
        const fetchStoreTags = async () => {
            try {
                const response = await getTags();
                setTagsList(response.tags);
            }
            catch(err) {
                console.log(err);
            }
        }

        fetchStoreTags();
    }, []);

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleSave = async () => {
        if(buttonAvailable) {
            if(selectedProducts.length > 0) {
                const callData = {
                    Tag: selectedTags
                }

                const updatePromises = selectedProducts.map(productId => updateProduct(callData, productId));

                const updateAllPromise = Promise.all(updatePromises);

                toast.promise(
                    updateAllPromise,
                    {
                        pending: {
                            render() {
                                return 'Adding tags...';
                            },
                            className: 'toast-pending',
                        },
                        success: {
                            render() {
                                return 'Tags addeded successfully.';
                            },
                        },
                    }
                );

                try {
                    await updateAllPromise;
                    dispatch(fetchInventoryProducts());
                    dispatch(closeModal());
                    setSelectedProducts([]);
                }
                catch (err) {
                    showToast('Failed to add tags to some or all products. Please try again.', 'error');
                }
            }
        }
        else {
            showToast('Please add tags.', 'warning');
        }
    }

    useEffect(() => {
        if(selectedTags.length > 0) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedTags]);

    return (
        <div className='w-[44%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-[10px]'>
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className='font-semibold text-2xl text-[#121212]'>Add tags</h1>
                    </div>

                    <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div ref={searchInputBoxRef} className="relative flex items-center gap-1 border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px]">
                    <div className="w-6 h-6 flex items-center justify-center">
                        <img src={Search} alt="" />
                    </div>

                    <input 
                        className='w-[calc(100%-24px)] bg-transparent outline-none placeholder:font-normal font-medium text-base placeholder:text-[#666666] text-[#121212]' 
                        id='tag-search' 
                        name='tag-search' 
                        placeholder='Press enter to separate tags'
                        type="text" 
                        value={searchValue} 
                        onChange={handleTagSearch} 
                        onKeyDown={handleSearchKeyDown}
                    />

                    {
                        searchValue.trim() &&
                        <div ref={searchResultDropdownRef} className="absolute z-10 top-14 left-0 w-full border border-[#EAEAEA] rounded-xl overflow-hidden shadow-[0px_0px_12px_0px_#0000003D]">
                            {tagsList.filter(item => item.toLowerCase().includes(searchValue.toLowerCase())).map(tag => {
                                let isSelected = selectedTags.some(selected => selected === tag);

                                return (
                                    <div key={tag} onClick={(e) => handleTagResultDropdownItemClick(e, tag)} className="w-full px-3 py-4 flex gap-[10px] bg-[#FFFFFF] hover:bg-[#F5F5F5]">
                                        <div className={`w-6 h-6 cursor-pointer rounded-md ${isSelected ? '' : 'border border-[#D1D5DB]'} `}>
                                            <img className='cursor-pointer' src={isSelected ? CheckboxSelected : undefined} alt="" />
                                        </div>

                                        <p className='font-medium select-none text-base text-[#666666]'>
                                            {tag}
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                    }
                </div>

                {
                    selectedTags.length > 0 &&
                    <div className="flex flex-wrap gap-2">
                        {selectedTags.map(tag => {
                            return (
                                <div key={tag} className="flex items-center gap-[6px] bg-[#C1FCDA] px-3 py-[6px] rounded-2xl">
                                    <p className='font-medium text-sm text-[#000000DE]'>{tag}</p>

                                    <button onClick={(e) => handleTagResultDropdownItemClick(e, tag)} className="outline-none w-3 h-[14px] flex items-center justify-center">
                                        <img src={CrossSmall} alt="" />
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                }
            </div>

            <button onClick={handleSave} className={`px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg'} text-buttonText rounded font-semibold text-base`}>Save tags</button>
        </div>
    )
}

export default AddTags;
